import { useMemo } from 'react';
import { format } from 'date-fns';

import { NonFinancialDriversView } from '@futrli/views/views/NonFinancialDriversView/NonFinancialDriversView';
import { useApiView } from '@futrli/views/hooks/useApiView';

import { generateMonthlyDateLabels } from '../components/drivers-grid/utils';

const YEARS_IN_PAST_TO_SHOW = 2;
const YEARS_IN_FUTURE_TO_SHOW = 3;

export const useNonFinancialDriversApiView = (workspaceId: string, organisationId: string) => {
  const view = useApiView(
    useMemo(() => new NonFinancialDriversView(workspaceId, organisationId), [workspaceId, organisationId])
  );

  const { columns, startColumn } = useMemo(() => {
    const startDate = new Date();
    const endDate = new Date();

    startDate.setFullYear(startDate.getFullYear() - YEARS_IN_PAST_TO_SHOW);
    endDate.setFullYear(endDate.getFullYear() + YEARS_IN_FUTURE_TO_SHOW);
    endDate.setMonth(endDate.getMonth() - 1);

    return {
      columns: generateMonthlyDateLabels(startDate, endDate),
      startColumn: format(new Date(), 'yyyy-MM')
    };
  }, []);

  return {
    ...view.state,
    columns,
    startColumn,
    createGroup: view.createGroup.bind(view),
    deleteDriver: view.deleteDriver.bind(view),
    deleteGroup: view.deleteGroup.bind(view),
    duplicateDriver: view.duplicateDriver.bind(view),
    updateGroup: view.updateGroup.bind(view),
    updateGroupAndOrdering: view.updateGroupAndOrdering.bind(view),
    updateDriverOrdering: view.updateDriverOrdering.bind(view)
  };
};
